import * as React from 'react'
import type { SVGProps } from 'react'
export interface BrainIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * brain
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const BrainIcon = (props: BrainIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M15.5 13a3.5 3.5 0 0 0-3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1-7 0v-1.8" />
        <path d="M17.5 16a3.5 3.5 0 0 0 0-7H17" />
        <path d="M19 9.3V6.5a3.5 3.5 0 0 0-7 0M6.5 16a3.5 3.5 0 0 1 0-7H7" />
        <path d="M5 9.3V6.5a3.5 3.5 0 0 1 7 0v10" />
      </g>
    </svg>
  )
}
